import { Text } from "@/components/Text";

export const EmptyDataDash = () => (
  <Text className="text-sm text-slate-400">—</Text>
);
